import { type ResultSourceName } from '@/app/live-election/types';

/**
 * Keyed by election AND party AND sources. My Election's constituency-only keys are not a
 * model here: two parties viewing one election must never share a cache entry, because the
 * viewer block and declared strongholds are party-specific.
 */
export const liveElectionKeys = {
	all: ['live-election'] as const,
	summary: (electionId: number, partyId: number, sources: ResultSourceName[]) =>
		[...liveElectionKeys.all, 'summary', electionId, partyId, sources.join(',')] as const,
	summaries: (electionId: number) => [...liveElectionKeys.all, 'summary', electionId] as const,
	strongholds: (electionId: number, partyId: number) => [...liveElectionKeys.all, 'strongholds', electionId, partyId] as const,
};
